import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
const MenuItem = (props) => {
    const [activeItem, setActiveItem] = useState(0);
    const navigate = useNavigate();
    function handleClick(e, path) {
        e.preventDefault();
        setTimeout(() => {
            navigate(path);
        }, 1000);
    }
    function slideBg() {
        document.querySelector(".menu-bar").classList.remove("menu-bar-active");
        document.querySelector(".menu").classList.remove("menu-active");
        document
            .querySelector(".menu-button")
            .classList.remove("menu-button-active");
        document.querySelector(".slidebg").classList.add("slide-active");

        setTimeout(() => {
            let slideBg = document.querySelector(".slidebg");
            slideBg.style.opacity = "0";
            slideBg.style.transition = "opacity .3s";
            setTimeout(() => {
                slideBg.style.opacity = "1";
                slideBg.classList.remove("slide-active");
                document.querySelector(".menu").classList.remove("menu-active");
                document.querySelector(".menu-bar").classList.remove("menu-bar-active");
                document
                    .querySelector(".menu-button")
                    .classList.remove("menu-button-active");
            }, 300);
        }, 1000);
    }
    return (
        <>
            {props.names.map((name, index) => {
                return (
                    <Link
                        to={name === "HOME" ? "/" : `/${name.toLowerCase()}`}
                        onClick={(e) =>
                            handleClick(e, name === "HOME" ? "/" : `/${name.toLowerCase()}`)
                        }
                    >
                        <a
                            href="" onClick={
                                () => {
                                    slideBg();
                                    setActiveItem(index);
                                }
                            }
                            className={activeItem === index ? "active-item" : ""}
                        >
                            {" "}
                            <li> {name} </li>{" "}
                        </a>
                    </Link>
                );
            })}
        </>
    );
};

export default MenuItem;
